var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-item shadowless" }, [
    _c("div", { staticClass: "card-item-header" }, [
      _c("div", { staticClass: "transaction-header-resume" }, [
        _c("div", { staticClass: "transaction-header-amount" }, [
          _c(
            "span",
            {
              staticClass: "content-title",
              attrs: { id: `${_vm.boleto._id}-amount` },
            },
            [_vm._v(" Valor: ")]
          ),
          _c("span", { attrs: { id: `${_vm.boleto._id}-amount` } }, [
            _vm._v(" $ " + _vm._s(_vm.formatNumber(_vm.boleto.amount)) + " "),
          ]),
        ]),
        _c("div", { staticClass: "transaction-header-payments" }, [
          _c("span", { staticClass: "content-title" }, [_vm._v("Parcela")]),
          _c(
            "div",
            [
              _c(
                "b-tooltip",
                {
                  key: _vm.boleto.paymentNumber,
                  attrs: { position: "is-right", type: "is-light" },
                },
                [
                  _c(
                    "span",
                    { staticClass: "content-value transaction-header-payment" },
                    [_vm._v(_vm._s(`${_vm.boleto.paymentNumber}`))]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "transaction-header-payed" }, [
          _c("span", { staticClass: "content-title" }, [
            _vm._v("Data de vencimento: "),
          ]),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.dateToFormatedString(_vm.boleto.dueDateBoleto, "DD/MM/YYYY")
              )
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "transaction-header-status" },
          [
            _c(
              "b-tooltip",
              {
                attrs: {
                  label: "Status do pagamento",
                  position: "is-bottom",
                  type: "is-light",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tag med-size-text",
                    class: `${
                      _vm.boleto.status ? _vm.boleto.status.toLowerCase() : ""
                    }`,
                  },
                  [_vm._v(" " + _vm._s(_vm.boleto.statusTranslate) + " ")]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }